import { useNavigate } from "react-router-dom";
import { ScrollText, ShieldHalf, Workflow, FileSearch, ClipboardCheck } from "lucide-react";
import PageHero from "../components/PageHero";
import FinalCTA from "../components/FinalCTA";

const services = [
  {
    icon: ScrollText,
    title: "Governance, Risk, and Compliance (GRC) Frameworks",
    copy: "We help organizations establish practical governance structures, risk management processes, and compliance frameworks that support accountability and reduce exposure to preventable issues.",
  },
  {
    icon: ShieldHalf,
    title: "Operational Resilience Planning",
    copy: "Prepare your organization to maintain continuity during disruption through structured resilience planning, process mapping, and response readiness.",
  },
  {
    icon: Workflow,
    title: "Process Optimization",
    copy: "Identify inefficiencies, reduce operational friction, and improve consistency across core workflows to create measurable cost and performance benefits.",
  },
  {
    icon: FileSearch,
    title: "Compliance Due Diligence",
    copy: "Assess obligations, review controls, and strengthen documentation to reduce risk exposure and support better decision-making.",
  },
  {
    icon: ClipboardCheck,
    title: "Internal Controls and Governance Support",
    copy: "Develop clear operating structures, control mechanisms, and oversight practices that improve reliability and reduce avoidable breakdowns.",
  },
];

const Services = () => {
  const navigate = useNavigate();
  return (
    <div data-testid="services-page">
      <PageHero
        overline="Services"
        title="Services"
        subtitle="Advisory services designed to improve structure, control, and operational reliability."
        image="https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      />

      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
          <div className="grid gap-px bg-slate-200 border border-slate-200">
            {services.map((s, i) => (
              <div
                key={s.title}
                data-testid={`service-card-${i + 1}`}
                className="bg-white p-10 sm:p-12 grid md:grid-cols-12 gap-6 items-start hover:bg-slate-50 transition-colors duration-300"
              >
                <div className="md:col-span-1 flex md:block items-center gap-4">
                  <span className="font-mono text-sm text-gold">0{i + 1}</span>
                </div>
                <div className="md:col-span-2">
                  <s.icon size={40} strokeWidth={1.3} className="text-navy" />
                </div>
                <div className="md:col-span-9">
                  <h3 className="text-xl sm:text-2xl font-medium text-navy">{s.title}</h3>
                  <p className="mt-3 text-base leading-relaxed text-slate-600 max-w-3xl">{s.copy}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-navy p-10 sm:p-14 text-center">
            <h2 className="text-2xl sm:text-3xl font-medium text-white max-w-2xl mx-auto">
              Need a stable consulting partner for governance, compliance, and operational efficiency?
            </h2>
            <p className="mt-4 text-slate-300">Let's discuss your priorities.</p>
            <button
              data-testid="services-cta-button"
              onClick={() => navigate("/contact")}
              className="mt-8 bg-gold text-white hover:bg-gold-hover transition-colors duration-200 px-8 py-4 text-sm font-semibold tracking-wide"
            >
              Schedule a Consultation
            </button>
          </div>
        </div>
      </section>

      <FinalCTA />
    </div>
  );
};

export default Services;
